import { DomTableGeometryResolver, HighlightsController } from '@databases/highlights';
import '@databases/highlights/styles';
import { container } from '@databases/service-container';

const SCROLLABLE_INNER_CONTAINER_ID = 'scrollable-inner-container';
const SELECTIONS_CONTAINER_ELEMENT_ID = 'selections-overlay-container';

/**
 * Initializes the HighlightsController for the table view with the DomTableGeometryResolver.
 * This can be used to create layers and draw highlights, user intents, rovo cursors, presence, etc.
 * all on top of the database reliably.
 */
export function initializeTableHighlightsController() {
  function setup() {
    container.registerSingleton('TableHighlightsController', () => {
      const resolver = new DomTableGeometryResolver(() =>
        document.getElementById(SCROLLABLE_INNER_CONTAINER_ID)
      );

      return new HighlightsController(resolver, {
        id: SELECTIONS_CONTAINER_ELEMENT_ID,
      });
    });

    const controller = container.resolve('TableHighlightsController');

    controller.mount();
  }

  function dispose() {
    const controller = container.resolve('TableHighlightsController');

    controller.dispose();
  }

  return {
    setup,
    dispose,
  };
}
